import React from 'react'

import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';

import Border from './Border'

export default class SmartTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tabs: props.tabs,
      activeTabIndex: props.activeTabIndex
    }

  }

  render() {
    let {
      tabs,
      activeTabIndex
    } = this.state

    return (
      <Tabs
        defaultTab={activeTabIndex.toString()}
        onChange={activeTabIndex => this.setState({ activeTabIndex }) }
      >
        <TabList>
          { tabs.map((tab,index) => {
              let className = activeTabIndex.toString() === index.toString() ? "tab-active" : "tab-inactive"
              return (
                <Tab
                  tabFor={index.toString()}
                  className={className}
                >
                  { tab }
                </Tab>
              )
            })
          }
        </TabList>
        { tabs.map((tab, index) => {
            return (
              <TabPanel tabId={index.toString()}>
                { this.props.renderTab(tab, index) }
              </TabPanel>
            )
          })
        }
      </Tabs>
    )
  }
}

SmartTabs.defaultProps = {
  tabs: [],
  activeTabIndex: 0,
}
